/** PURE_IMPORTS_START ._BoundCallbackObservable PURE_IMPORTS_END */
import { BoundCallbackObservable } from './BoundCallbackObservable';
export var bindCallback = BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/bindCallback.js
// module id = 761
// module chunks = 0